
import { API_URL } from "./../../utils/api-utils";
export const url = `${API_URL.Job}/hubs/plan`;
export const methodRemovePlan = `RemoveExecutionPLanList`;
export const methodOnPlanStatusChanged = `OnPlanStatusChanged`;//`UpdateExecutionPLanList`;
//export const methodUpdateHistory = `OnPlanStatusChanged`;//`NewExcutionHistoryList`;
//export const methodUpdateInstance = `OnPlanStatusChanged`;//`AllExcutionInstanceListUpdate`;
export const methodLogDeployPlan = `OnDeployPlanLogChanged`;
